export class ConfirmationDialogConfig {
  public maxWidth = '600px';
  public minWidth = '300px';
  public panelClass = 'confirm-dialog-panel';
  public position = {
    top: '20%',
  };
  public disableClose = false;
  public autoFocus = true;

  constructor(public data?: ConfirmationDialogData) {
    this.panelClass = this.data.panelClass || this.panelClass;
  }
}

export class ConfirmationDialogData {
  constructor(
    public title: string,
    public text: string,
    public value?: any,
    public type?: string,
    public campaigns?: any,
    public proceedButtonText?: string,
    public cancelButtonText?: string,
    public proceedButtonText_2?: string,
    public panelClass?: string,
    public showDontAskAgain?: boolean,
    public cancelButtonIsNotRequired?: boolean,
    // In-app links in the text navigate through the router and close the dialog, instead of reloading the page.
    public routeInternalLinks?: boolean,
  ) {}
}
